import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)
export const constantRoutes = [{
	path: '/',
	component: () => import('@/views/index'),
	hidden: true,
}, {
	path: '/index2',
	component: () => import('@/views/index2'),
	hidden: true,
},]
export const asyncRoutes = []

//   路由模式，可选值为 history 或 hash
//   routerMode: 'hash',

const router = new VueRouter({
	base:  './',
	mode: 'hash', 
	scrollBehavior: () => ({
		y: 0,
	}),
	routes: constantRoutes,
})

export function resetRouter() {
	location.reload()
}

export default router
